import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
import { toggleUserModal } from '../../../redux/actions/userActions';
export const usersDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.createUsers',
        popover: {
          title: 'Create New Users',
          description:
            'Use this feature to add new users to the system. You can specify user roles, permissions, and other relevant details during the creation process.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.importUsers',
        popover: {
          title: 'Import Users',
          description:
            'Click here to import users in bulk. This feature allows you to upload a file with user data, making it easier to add multiple users at once.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.activeUsers',
        popover: {
          title: 'View Active Users',
          description:
            'This section displays all currently active users in the system. You can manage user accounts, update their details, or deactivate them if necessary.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.allActiveUsers',
        popover: {
          title: 'All Active Users Overview',
          description:
            'Here you can view and manage all active users, ensuring that user information is up-to-date and accurate across the system.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.usersMainTable',
        popover: {
          title: 'Users Management Table',
          description:
            'This table provides a comprehensive view of all users in the system. Use it to manage user accounts, including editing, updating, or removing users as needed.',
          side: 'left',
          align: 'start',
          onNextClick: () => {
            dispatch(toggleUserModal());
            driverObj.moveNext();
          },
        },
      },
    ],
  });
  return driverObj;
};
export default usersDriverObj;
